import styled from '@emotion/styled';
import { colors } from 'theme/colors';
import { css } from '@mui/material';

interface IStyledCounter {
  open: boolean;
}

const StyledCounter = styled.div<IStyledCounter>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: auto;
  height: 24px;
  padding: 2px 4px;
  border-radius: 4px;
  background-color: ${colors.error600};

  ${(props: IStyledCounter) =>
    !props.open &&
    css`
      display: none;
    `}
  & span {
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: ${colors.white} !important;
  }
`;

export { StyledCounter };
